import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import { SnackBarModule } from "../../../modules/SnackBarModule";
import { ProcessamentoService } from "../../../services/ProcessamentoService";

export default {
    name: "ImportarAprovacoes",
    components: {
        Breadcrumb
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Aprovações',
                disabled: false
            },
            {
                text: 'Importar Aprovações',
                disabled: true
            }
        ],
        arquivo: null,
        loading: false,
        uploadProgress: null,
        blockInputFile: false,
        scheduledList: [],
        isDragOver: false
    }),
    created() {
        this.loadScheduledList();
    },
    methods: {
        async loadScheduledList() {
            const scheduledList = await ProcessamentoService.scheduled('aprovacao');
            this.scheduledList = scheduledList.data;
        },
        async refreshPage() {
            this.loadScheduledList();
            await SnackBarModule('Lista de Processos Atualizada', 'info');
        },
        async retryProcessamento(item) {
            try {
                const formData = new FormData();
                formData.append('id', item.id);

                const response = await ProcessamentoService.retry(formData);
                if (response) {
                    this.loadScheduledList();
                } 
            } catch (error) {
                console.error('Erro ao tentar reprocessar o item:', error);
            }
        },
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        handleFileSelect(event) {
            const file = event.target.files[0];
            if (file) {
                this.arquivo = file;
                this.uploadFile();
            }
        },
        handleDragOver(event) {
            event.preventDefault();
            this.isDragOver = true;
        },
        handleDragLeave(event) {
            event.preventDefault();
            this.isDragOver = false;
        },
        handleFileDrop(event) {
            event.preventDefault();
            this.isDragOver = false;
            
            const files = event.dataTransfer.files;
            if (files.length > 0) {
                this.arquivo = files[0];
                this.uploadFile();
            }
        },
        uploadFile() {
            if (!this.arquivo) {
                console.error('Nenhum arquivo selecionado.');
                return;
            }

            this.blockInputFile = true;
            const formData = new FormData();
            formData.append('arquivo', this.arquivo);
            formData.append('type', 'aprovacao');

            ProcessamentoService.store(formData)
                .then(response => {
                    if (response.error) {
                        this.blockInputFile = false;
                        this.uploadProgress = null;
                        this.arquivo = null;
                        SnackBarModule('Ocorreu um erro devido ao documento ser incompatível com a entidade', 'error');
                        return;
                    }

                    let progress = 0;
                    this.blockInputFile = true;
                    this.arquivo = null;
                    const interval = setInterval(() => {
                        progress += Math.random() * 10;
                        if (progress >= 100) {
                            clearInterval(interval);
                            this.uploadProgress = null;
                            this.loadScheduledList();
                        } else {
                            this.uploadProgress = progress;
                        }
                    }, 500);
                })
                .catch(error => {
                    console.error('Erro ao enviar o arquivo:', error);
                    this.uploadProgress = null;
                    this.blockInputFile = false;
                    this.arquivo = null;
                    SnackBarModule('Ocorreu um erro devido ao documento ser incompatível com a entidade', 'error');
                });
                this.blockInputFile = false;
        },
        getStatusClass(item) {
            if (!item.processado) {
                return 'awaiting-process';
            } else if (item.erro) {
                return 'processing-error';
            } else {
                return 'processing-success';
            }
        },
        getStatusText(item) {
            if (!item.processado) {
                return 'Aguardando Processamento';
            } else if (item.erro) {
                return 'Erro de Processamento';
            } else {
                return 'Processamento concluído';
            }
        },
        getStatusIcon(item) {
            if (!item.processado) {
                return 'mdi-clock-outline';
            } else if (item.erro) {
                return 'mdi-alert-circle-outline';
            } else {
                return 'mdi-checkbox-marked-circle-outline';
            }
        },
        getStatusChipColor(item) {
            if (!item.processado) {
                return 'warning';
            } else if (item.erro) {
                return 'error';
            } else {
                return 'success';
            }
        },
        getStatusTextColor(item) {
            if (!item.processado) {
                return 'white';
            } else if (item.erro) {
                return 'white';
            } else {
                return 'white';
            }
        },
        getErrorSummary(erro) {
            if (!erro) return '';
            const lines = erro.split('\n');
            if (lines.length > 0 && lines[0].includes('Total de registros com erro:')) {
                return lines[0];
            }
            return 'Erro durante o processamento';
        },
        parseErrors(erro) {
            if (!erro) return [];
            
            const errors = [];
            const lines = erro.split('\n');
            let currentError = null;
            
            for (let i = 0; i < lines.length; i++) {
                const line = lines[i].trim();
                
                if (line.startsWith('--- Erro #')) {
                    if (currentError) {
                        errors.push(currentError);
                    }
                    
                    const match = line.match(/Linha (\d+)/);
                    currentError = {
                        linha: match ? match[1] : 'N/A',
                        motivo: '',
                        dados: {}
                    };
                } else if (line.startsWith('Motivo:') && currentError) {
                    currentError.motivo = line.replace('Motivo:', '').trim();
                } else if (line.startsWith('Dados:') && currentError) {
                    const dadosStr = line.replace('Dados:', '').trim();
                    const parts = dadosStr.split(',');
                    
                    parts.forEach(part => {
                        const [key, value] = part.split('=').map(s => s.trim());
                        if (key && value) {
                            currentError.dados[key] = value;
                        }
                    });
                }
            }
            
            if (currentError) {
                errors.push(currentError);
            }
            
            if (errors.length === 0 && erro.length > 0) {
                errors.push({
                    linha: 'N/A',
                    motivo: erro.substring(0, 200),
                    dados: {}
                });
            }
            
            return errors;
        },
        formatFieldName(key) {
            const fieldNames = {
                'Código': 'Código Aprovação',
                'Ano': 'Ano Exercício',
                'Data': 'Data Aprovação',
                'Valor': 'Valor Aprovação'
            };
            return fieldNames[key] || key;
        }
    }
};